import { Box, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { IconAdd } from 'assets/img';
import { LwButton, LwFormInput } from 'redesign';
import { useFormArray } from 'shared/hooks/use-form-array';
import { AddClaFormValues, AddClaScaleFormValues } from './add-cla-dialog.types';
import { ScaleItem } from './scale-item';

const DEFAULT_SCALE: AddClaScaleFormValues = { scale: '', steps: [] };

export const AddClaForm = () => {
  const { t } = useTranslation('partner-screen-specific');
  const { control } = useFormContext<AddClaFormValues>();
  const {
    fields: scaleFields,
    appendElement: appendScale,
    deleteElement: removeScale,
  } = useFormArray<AddClaFormValues, 'scales'>('scales', DEFAULT_SCALE);

  const addScaleLabel =
    scaleFields.length === 0
      ? t('partner-worker-detail.cla-form.start-with-a-scale.label', {
          ns: 'partner-screen-specific',
        })
      : t('partner-worker-detail.cla-form.add-another-scale.label', {
          ns: 'partner-screen-specific',
        });

  return (
    <Wrapper>
      <NameField>
        <LwFormInput
          name="name"
          control={control}
          label={t('partner-worker-detail.cla-form.name.label', { ns: 'partner-screen-specific' })}
          placeholder={t('partner-worker-detail.cla-form.name.placeholder', {
            ns: 'partner-screen-specific',
          })}
          rules={{
            required: t('partner-worker-detail.cla-form.name.required', {
              ns: 'partner-screen-specific',
            }),
          }}
        />
      </NameField>

      {scaleFields.map((field, scaleIndex) => (
        <ScaleItem key={field.id} scaleIndex={scaleIndex} onRemove={removeScale} />
      ))}

      <AddScaleRow>
        <LwButton
          onClick={() => appendScale()}
          startIcon={<IconAdd width={16} height={16} />}
          color="tertiary"
          iconColorMode="stroke"
        >
          {addScaleLabel}
        </LwButton>
      </AddScaleRow>
    </Wrapper>
  );
};

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

const NameField = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3, 0, 4),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const AddScaleRow = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
}));
